import { isDevelopment } from './mode';

/**
 * Asserts that a given condition is true. If the condition is false, it logs an assertion failure
 * message to the console. Additionally, in non-production environments, it throws an error with
 * the provided message.
 *
 * @param condition - The condition to evaluate. If `false`, the assertion fails.
 * @param message - The message to display or throw when the assertion fails.
 *
 * @throws {Error} Throws an error with the provided message if the condition is false
 * and the environment mode is not 'production'.
 */
export function assert(condition: boolean, message: string) {
  if (!condition) {
    console.error('Assertion failed:', message);
  }

  // we won't throw errors in production, but we will in qa and stage
  if (!condition && isDevelopment()) {
    throw new Error(message);
  }
}
